import type { OpenAPI } from "../../interfaces";

export const notifications = (api) => ({
  get(
    page: number,
    success: (data: OpenAPI.GET<"/notifications">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "GET",
      `/notifications?page=${page}`,
      null,
      success,
      fail,
    );
  },
  markAsSeen(
    notificationIds: string[],
    markAllAsSeen: boolean,
    success: (data: OpenAPI.PUT<"/notifications/seen">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "PUT",
      `/notifications/seen`,
      { notifications: notificationIds, markAllAsSeen },
      success,
      fail,
    );
  },
  markAsInteracted(
    notification: string,
    success: (
      data: OpenAPI.PUT<"/notifications/{id}/interacted">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "PUT",
      `/notifications/${notification}/interacted`,
      null,
      success,
      fail,
    );
  },
});
